import { createContext, useState } from "react";
import { TOKEN_KEY } from "../constants";

export const authContext = createContext()

export default function AuthContext({ children }){
    const [token, setToken] = useState(null)
    const [user, setUser] = useState({})
    const logOut = () => {
        localStorage.removeItem(TOKEN_KEY)
        setToken(null)
    }

    return (
        <authContext.Provider value={{
            token, setToken, user, setUser, logOut
        }}>
            {children}
        </authContext.Provider>
    )
}